export enum RelacionFamiliar {
  POSTULANTE = 1,
  CONYUGE = 2,
  HIJO = 3,
  ABUELO = 4,
  PADRE = 5,
  NIETO = 6,
  HERMANO = 7,
  MADRE = 8
}
